import * as React from "react"
import { batch } from "@preact/signals-react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { FORMAT_DATE_BACK, formatDate, getPreviousDate } from "@ui-seeker/utils"

import { DATE_PERIODS } from "@constants"
import { ImageSkuBlock, SkuInfoBlock } from "@components"
import { useBuildExternalURL } from "@hooks"
import { commonFiltersValue } from "@signals"
import { evolutionSkuCurrentPeriod, evolutionSkuDataFilters, priceDiscountEndDate } from "../../../../@signals"


export default function skuColumn() {
	return [{
		name: 'category', label: 'Category',
		options: { display: 'excluded' }
	}, {
		name: 'brand', label: 'Brand',
		options: { display: 'excluded' }
	}, {
		name: 'skuName', label: 'Product Name',
		options: {
			headerAlign: 'center',
			setCellHeaderProps: () => ({ sx: {
				minWidth: 180
			}}),
			customBodyRowRenderLite: (value, { category, brand, ean, skuID, skuName, siteID, productID, country, reference }) => {
				const { productURL } = useBuildExternalURL({ siteData: { siteID, productID } })
				return <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 2 }}>
					<Box>
						<ImageSkuBlock
							skuID={skuID}
							skuName={skuName}
						/>
					</Box>
					<Box>
						<SkuInfoBlock
							sku={value}
							skuID={skuID}
							category={category}
							brand={brand}
							reference={reference}
							ean={ean}
							productURL={productURL}
						/>
						<ShowSkuEvolution skuID={skuID} country={country}/>
					</Box>
				</Box>
			}
		}
	}]
}

const ShowSkuEvolution = ({skuID, country}) => {
	const newFilters = commonFiltersValue.peek()

    const handleClick = () => { batch(() => {
        priceDiscountEndDate.value = newFilters.endDate
        let startDate = formatDate(getPreviousDate({days: 6}, priceDiscountEndDate.value), { format: FORMAT_DATE_BACK, receivedFormat: "%Y-%m-%dT%H:%M:%S.%LZ" })

        evolutionSkuCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS

        evolutionSkuDataFilters.value = {
            ...commonFiltersValue.peek(),
            startDate: startDate,
            endDate: priceDiscountEndDate.value,
            sku: [skuID],
			country: [country]
        }
    })}

    return <Box sx={{ display: 'flex', alignItems: 'flex-end'}} onClick={handleClick} >
        <Typography variant="caption" sx={{ display: 'block', color: "text.primary", mt: 1, mr: 0.5, cursor: 'pointer', "&:hover":{ textDecoration: 'underline'} }}>
            Show Price Evolution 
        </Typography>
        <IconSeeker icon={'chart-line'} sx={{ mr: 0.5, margin: .5, color: 'primary.main'}}/>
    </Box>
}